import { html as t, when as r } from "@microsoft/fast-element";
const o = t`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1.25C10.4812 1.25 9.25 2.48122 9.25 4C9.25 5.51878 10.4812 6.75 12 6.75C13.1134 6.75 14.0722 6.08838 14.5047 5.13687C17.3372 6.03833 19.5071 8.42944 20.0928 11.3881C20.1732 11.7944 20.5678 12.0586 20.9741 11.9781C21.3804 11.8977 21.6446 11.5031 21.5642 11.0968C20.8555 7.51666 18.1891 4.64299 14.7262 3.63642C14.5483 2.28949 13.3955 1.25 12 1.25Z"
      fill="currentColor"
    />
    <path
      d="M2.40809 14.7573C1.70721 15.2557 1.25 16.0745 1.25 17C1.25 18.5188 2.48122 19.75 4 19.75C5.51878 19.75 6.75 18.5188 6.75 17C6.75 15.4812 5.51878 14.25 4 14.25C3.94786 14.25 3.89606 14.2515 3.84464 14.2543C3.78235 13.8456 3.75 13.4268 3.75 13C3.75 10.2992 5.04701 7.90151 7.05532 6.39533C7.3867 6.1468 7.45386 5.6767 7.20534 5.34533C6.95681 5.01395 6.48671 4.94679 6.15534 5.19531C3.78558 6.97258 2.25 9.80705 2.25 13C2.25 13.5995 2.30419 14.1868 2.40809 14.7573Z"
      fill="currentColor"
    />
    <path
      d="M20 14.25C18.4812 14.25 17.25 15.4812 17.25 17C17.25 17.6745 17.4928 18.2923 17.8959 18.7707C16.3975 20.3015 14.3098 21.25 12 21.25C10.6815 21.25 9.43734 20.9412 8.33377 20.3928C7.96284 20.2085 7.5127 20.3598 7.32836 20.7307C7.14403 21.1016 7.29529 21.5518 7.66623 21.7361C8.97258 22.3853 10.4448 22.75 12 22.75C14.83 22.75 17.3788 21.5435 19.159 19.619C19.4241 19.7041 19.7067 19.75 20 19.75C21.5188 19.75 22.75 18.5188 22.75 17C22.75 15.4812 21.5188 14.25 20 14.25Z"
      fill="currentColor"
    />
    <path
      d="M8.25 13.5053V15.3077C8.25 16.1652 8.85846 16.7899 9.51019 17.1576C10.185 17.5382 11.0668 17.75 12 17.75C12.9332 17.75 13.815 17.5382 14.4898 17.1576C15.1415 16.7899 15.75 16.1652 15.75 15.3077V13.5053C15.5714 13.6404 15.3935 13.7546 15.2268 13.8487C14.288 14.3782 13.1425 14.6346 12 14.6346C10.8575 14.6346 9.71197 14.3782 8.77321 13.8487C8.60654 13.7546 8.4286 13.6404 8.25 13.5053Z"
      fill="currentColor"
    />
    <path
      d="M15.75 10.6923C15.75 9.83478 15.1415 9.21007 14.4898 8.84243C13.815 8.46177 12.9332 8.25 12 8.25C11.0668 8.25 10.185 8.46177 9.51019 8.84243C8.85846 9.21007 8.25 9.83478 8.25 10.6923C8.25 11.5498 8.85846 12.1745 9.51019 12.5422C10.185 12.9228 11.0668 13.1346 12 13.1346C12.9332 13.1346 13.815 12.9228 14.4898 12.5422C15.1415 12.1745 15.75 11.5498 15.75 10.6923Z"
      fill="currentColor"
    />
  </svg>
`, l = t`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 10.6923C15 11.6269 13.6569 12.3846 12 12.3846C10.3431 12.3846 9 11.6269 9 10.6923M15 10.6923C15 9.75767 13.6569 9 12 9C10.3431 9 9 9.75767 9 10.6923M15 10.6923V15.3077C15 16.2423 13.6569 17 12 17C10.3431 17 9 16.2423 9 15.3077V10.6923M15 10.6923V12.2308V12.9487C15 13.8834 13.6569 14.641 12 14.641C10.3431 14.641 9 13.8834 9 12.9487V12.2308V10.6923"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 19C5.10457 19 6 18.1046 6 17C6 15.8954 5.10457 15 4 15C2.89543 15 2 15.8954 2 17C2 18.1046 2.89543 19 4 19Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 19C21.1046 19 22 18.1046 22 17C22 15.8954 21.1046 15 20 15C18.8954 15 18 15.8954 18 17C18 18.1046 18.8954 19 20 19Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8561 18.8306C17.2053 20.7698 14.7463 21.9999 12 21.9999C10.5632 21.9999 9.20496 21.6632 8 21.0644M20.8285 11.2424C20.143 7.77961 17.4711 5.03128 14.0497 4.23438M6.60533 5.79526C4.41629 7.43698 3 10.0531 3 12.9999C3 13.6873 3.07707 14.3568 3.22303 15"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`, e = t`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4717_37387)">
      <path
        d="M10 0.916748C8.66532 0.916748 7.58334 1.99873 7.58334 3.33341C7.58334 4.6681 8.66532 5.75008 10 5.75008C10.9384 5.75008 11.7519 5.21521 12.1523 4.43369C14.4191 5.19577 16.1493 7.12999 16.6213 9.51452C16.7018 9.92085 17.0964 10.185 17.5027 10.1046C17.909 10.0242 18.1732 9.62956 18.0928 9.22323C17.4983 6.22029 15.2765 3.80498 12.3837 2.9333C12.1931 1.78902 11.1984 0.916748 10 0.916748Z"
        fill="currentColor"
      />
      <path
        d="M1.87008 12.2432C1.29064 12.6846 0.916656 13.382 0.916656 14.1667C0.916656 15.5014 1.99863 16.5833 3.33332 16.5833C4.66801 16.5833 5.74999 15.5014 5.74999 14.1667C5.74999 12.832 4.66801 11.75 3.33332 11.75C3.32608 11.75 3.31885 11.75 3.31162 11.7501C3.27101 11.4506 3.25 11.1447 3.25 10.8335C3.25 8.62384 4.31096 6.66219 5.95443 5.42963C6.28581 5.18111 6.35297 4.71101 6.10445 4.37963C5.85593 4.04826 5.38583 3.98109 5.05445 4.22961C3.04953 5.73326 1.75 8.13172 1.75 10.8335C1.75 11.3136 1.7911 11.7847 1.87008 12.2432Z"
        fill="currentColor"
      />
      <path
        d="M16.6667 11.75C15.332 11.75 14.25 12.832 14.25 14.1667C14.25 14.7183 14.4348 15.2267 14.7459 15.6334C13.5258 16.8399 11.8501 17.5835 10 17.5835C8.92102 17.5835 7.90318 17.3309 7.00044 16.8823C6.62951 16.6979 6.17937 16.8492 5.99503 17.2201C5.81069 17.5911 5.96196 18.0412 6.33289 18.2255C7.43842 18.7749 8.68425 19.0835 10 19.0835C12.3665 19.0835 14.5007 18.0863 16.0042 16.4914C16.2147 16.5513 16.437 16.5833 16.6667 16.5833C18.0014 16.5833 19.0833 15.5014 19.0833 14.1667C19.0833 12.832 18.0014 11.75 16.6667 11.75Z"
        fill="currentColor"
      />
      <path
        d="M6.875 11.5625C6.98269 11.6367 7.08815 11.7019 7.18818 11.7583C8.01447 12.2244 9.01299 12.4455 10 12.4455C10.987 12.4455 11.9855 12.2244 12.8118 11.7583C12.9118 11.7019 13.0173 11.6367 13.125 11.5625V12.7564C13.125 13.471 12.6179 13.9916 12.0748 14.298C11.5125 14.6152 10.7777 14.7917 10 14.7917C9.22235 14.7917 8.4875 14.6152 7.92516 14.298C7.38205 13.9916 6.875 13.471 6.875 12.7564V11.5625Z"
        fill="currentColor"
      />
      <path
        d="M6.875 8.91026C6.875 8.19565 7.38205 7.67506 7.92516 7.36869C7.99545 7.32904 8.06844 7.29159 8.14387 7.2564C8.67188 7.01011 9.31955 6.875 10 6.875C10.6804 6.875 11.3281 7.01011 11.8561 7.2564C11.9316 7.29159 12.0045 7.32904 12.0748 7.36869C12.6179 7.67506 13.125 8.19565 13.125 8.91026C13.125 9.62486 12.6179 10.1455 12.0748 10.4518C11.5125 10.769 10.7777 10.9455 10 10.9455C9.22235 10.9455 8.4875 10.769 7.92516 10.4518C7.38205 10.1455 6.875 9.62486 6.875 8.91026Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4717_37387">
        <rect width="20" height="20" fill="none" />
      </clipPath>
    </defs>
  </svg>
`, i = t`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4717_37386)">
      <path
        d="M8.00002 0.733398C6.93227 0.733398 6.06669 1.59898 6.06669 2.66673C6.06669 3.73448 6.93227 4.60006 8.00002 4.60006C8.75076 4.60006 9.40155 4.17216 9.72181 3.54695C11.5353 4.15661 12.9195 5.70399 13.2971 7.61162C13.3614 7.93668 13.6771 8.14803 14.0022 8.08368C14.3272 8.01933 14.5386 7.70365 14.4742 7.37859C13.9987 4.97623 12.2212 3.04398 9.90698 2.34664C9.75446 1.43122 8.95873 0.733398 8.00002 0.733398Z"
        fill="currentColor"
      />
      <path
        d="M1.49608 9.79454C1.03252 10.1477 0.733337 10.7056 0.733337 11.3333C0.733337 12.4011 1.59892 13.2667 2.66667 13.2667C3.73442 13.2667 4.6 12.4011 4.6 11.3333C4.6 10.2656 3.73442 9.4 2.66667 9.4C2.66088 9.4 2.65509 9.40003 2.64931 9.40008C2.61682 9.16051 2.60001 8.91574 2.60001 8.6668C2.60001 6.89908 3.44878 5.32975 4.76356 4.3437C5.02866 4.14488 5.08239 3.7688 4.88357 3.5037C4.68475 3.23861 4.30867 3.18487 4.04357 3.38369C2.43964 4.58661 1.40001 6.50538 1.40001 8.6668C1.40001 9.05091 1.43289 9.42775 1.49608 9.79454Z"
        fill="currentColor"
      />
      <path
        d="M13.3333 9.4C12.2656 9.4 11.4 10.2656 11.4 11.3333C11.4 11.7746 11.5479 12.1814 11.7967 12.5068C10.8207 13.472 9.48007 14.0668 8.00001 14.0668C7.13683 14.0668 6.32256 13.8647 5.60037 13.5058C5.30362 13.3583 4.94351 13.4794 4.79604 13.7761C4.64857 14.0729 4.76958 14.433 5.06633 14.5804C5.95074 15.02 6.94741 15.2668 8.00001 15.2668C9.89319 15.2668 11.6006 14.4691 12.8034 13.1931C12.9718 13.241 13.1496 13.2667 13.3333 13.2667C14.4011 13.2667 15.2667 12.4011 15.2667 11.3333C15.2667 10.2656 14.4011 9.4 13.3333 9.4Z"
        fill="currentColor"
      />
      <path
        d="M5.50001 9.24996C5.58616 9.30932 5.67054 9.36149 5.75055 9.40663C6.41159 9.77952 7.21041 9.95641 8.00001 9.95641C8.78962 9.95641 9.58844 9.77952 10.2495 9.40663C10.3295 9.36149 10.4139 9.30932 10.5 9.24996V10.2051C10.5 10.7768 10.0944 11.1933 9.65989 11.4384C9.21001 11.6922 8.62214 11.8333 8.00001 11.8333C7.37789 11.8333 6.79001 11.6922 6.34014 11.4384C5.90565 11.1933 5.50001 10.7768 5.50001 10.2051V9.24996Z"
        fill="currentColor"
      />
      <path
        d="M5.50001 7.12821C5.50001 6.55652 5.90565 6.14005 6.34014 5.89495C6.39637 5.86323 6.45476 5.83327 6.51511 5.80512C6.93752 5.60809 7.45566 5.5 8.00001 5.5C8.54437 5.5 9.06251 5.60809 9.48492 5.80512C9.54526 5.83327 9.60365 5.86323 9.65989 5.89495C10.0944 6.14005 10.5 6.55652 10.5 7.12821C10.5 7.69989 10.0944 8.11636 9.65989 8.36146C9.21001 8.61523 8.62214 8.75641 8.00001 8.75641C7.37789 8.75641 6.79001 8.61523 6.34014 8.36146C5.90565 8.11636 5.50001 7.69989 5.50001 7.12821Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4717_37386">
        <rect width="16" height="16" fill="none" />
      </clipPath>
    </defs>
  </svg>
`, p = t`
  ${r((C) => C._type === "outline", l)}
  ${r((C) => C._type === "solid", o)}
  ${r((C) => C._type === "mini", e)}
  ${r((C) => C._type === "micro", i)}
`;
export {
  p as masterDataTemplate
};
